import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ACustomStepWizard } from '../../../shared/components/wizard/step-wizard/abstract-custom-step-wizard';
import { Observable, of, from } from 'rxjs';
import { IssueType } from '../../../core/models/IssueType';
import { SyncDataService } from './../../services/sync-data.service';
import { IFacadeTableDescriptor } from 'app/core/typings/IFacadeTableDescriptor';
import { IFacadeExportObject } from 'app/core/typings/IFacadeExportObject';
import { ISyncDataObject } from 'app/core/typings/ISyncDataObject';
import { IIssue } from 'app/core/typings/IIssue';

@Component({
  selector: 'app-import-step20',
  templateUrl: './import-step20.component.html',
  styleUrls: ['./import-step20.component.scss', './../../sync-data.component.scss']
})
export class ImportStep20Component implements OnChanges {
  @Input() data;
  @Input() onNext = false;
  @Input() onBackClick = false;
  @Output() isValidEmit = new EventEmitter<boolean>();
  public selectedTables: IFacadeTableDescriptor[];
  public filteredIssues: IIssue[];
  public isLoading = false;
  public loadingMessage = '';
  public showSendMailCheckbox = false;
  public messagebody: string;
  public messageToUser: string;

  private _existsNewUsers = true;

  constructor(private _syncDataService: SyncDataService) {
  }

  ngOnChanges(): void {
    if (this.data) {
      this.load();
    }

    if (this.onNext)
      this.isValid();

    if (this.onBackClick)
      this.load();
  }

  public load() {
    this.filteredIssues = null;
    this.data.syncData.EnabledMail = true;
    this.loadingMessage = 'SYNC_DATA.LOADING_MSJ';
    this.isLoading = true;
    this.getAvailableTables();
  }

  public isValid() {
    if (this.onNext) {
      this.isLoading = true;
      if (this.validateFinish()) {
        return from(this._syncDataService.executeImport(this.data.syncData).then(message => {
          this.isValidEmit.emit(false);
          if (message !== null) {
            this.messageToUser = message;
            return false;
          }
          this.isValidEmit.emit(true);
        }));
      }
      else {
        this.isLoading = false;
        this.isValidEmit.emit(false);
      }
    }

  }

  public onTableSelected(itemEntity: IFacadeTableDescriptor): void {
    this.data.syncData.EntityTables.forEach((item) => item.SelectedUI = false);
    this.selectedTables.forEach((item) => item.SelectedUI = false);
    itemEntity.SelectedUI = true;

    if (this.data.syncData.Reports) {
      this.filteredIssues = this.data.syncData.Reports.filter((x) => {
        return x.AffectedEntity === itemEntity.TableName || (x.Type === IssueType.Error &&
          !_.find(this.data.syncData.EntityTables, (entityTable: IFacadeTableDescriptor) => {
            return entityTable.TableName === x.AffectedEntity;
          }));
      }).sort((a, b) => {
        if (a.Type > b.Type) { return -1; }
        if (a.Type < b.Type) { return 1; }
        return 0;
      })
    }
  }

  public onSearchChange(searchValue: string) {
    if (searchValue.length > 0) {
      this.selectedTables = this.data.syncData.EntityTables.filter(table =>
        (table.DisplayName.toUpperCase().indexOf(searchValue.toUpperCase()) > -1) &&
        (table.Selected === true));
    }
    else {
      this.selectedTables = this.data.syncData.EntityTables.filter(table => table.Selected === true);
    }
  }

  public hasWarnings(itemEntity: IFacadeTableDescriptor): boolean {
    if (this.data.syncData.Reports) {
      return (this.data.syncData.Reports.find(x => x.AffectedEntity === itemEntity.TableName &&
        x.Type === IssueType.Warning) !== undefined);
    }
    else {
      return false;
    }
  }

  public hasErrors(itemEntity: IFacadeTableDescriptor): boolean {
    if (this.data.syncData.Reports) {
      return (this.data.syncData.Reports.find(x => x.AffectedEntity === itemEntity.TableName &&
        x.Type === IssueType.Error) !== undefined);
    }
    else {
      return false;
    }
  }

  public hasMessages(itemEntity: IFacadeTableDescriptor): boolean {
    if (this.data.syncData.Reports) {
      return (this.data.syncData.Reports.find(x => x.AffectedEntity === itemEntity.TableName &&
        x.Type === IssueType.Message) !== undefined);
    }
    else {
      return false;
    }
  }

  public selectWarning(index, event): void {
    if (event.target.tagName !== 'LABEL') {
      this.filteredIssues[index].AuthorizedByUser = !this.filteredIssues[index].AuthorizedByUser;
    }
  }

  public onPrevious() {
    this.data.syncData.EntityTables.forEach((item) => item.SelectedUI = false);
  }

  public changeEmail(event) {
    this.data.syncData.EnabledMail = !this.data.syncData.EnabledMail;
  }

  private getAvailableTables(): void {
    this.messageToUser = '';
    this.selectedTables = this.data.syncData.EntityTables.filter(x => x.Selected === true);

    this._syncDataService.validateImport(this.data.syncData).then((result: ISyncDataObject) => {
      if (result.ErrorLog) {
        this.messageToUser = result.ErrorLog;
      }
      else {
        this.data.syncData.ModifiedDescriptor = result.SyncDataContent.ModifiedDescriptor;
        this.data.syncData.AreNewUsers = result.SyncDataContent.AreNewUsers;
        this.data.syncData.EnabledMail = result.SyncDataContent.EnabledMail;
        this.data.syncData.Reports = result.IssuesList;
        this.data.syncData.FilePath = result.SyncDataContent.FilePath;

        if (this.selectedTables && this.selectedTables.length > 0) {
          this.onTableSelected(this.selectedTables[0]);
        }

        this._existsNewUsers = result.SyncDataContent.AreNewUsers;
        this.showSendEmails(result.SyncDataContent.EnabledMail);
      }
      this.isLoading = false;
    });
  }

  private validateFinish(): boolean {
    let result = true;
    let allTablesSelected: IFacadeTableDescriptor[];
    allTablesSelected = this.data.syncData.EntityTables.filter(table => table.Selected === true);

    if (allTablesSelected.length === 0) {
      result = false;
      this.messageToUser = 'SYNC_DATA.NO_ENTITIES_SELECTED';
    }

    let resultErrors = true;
    for (const entity of allTablesSelected) {
      const errorReports = this.data && this.data.syncData && this.data.syncData.Reports &&
        this.data.syncData.Reports.some(x => x.Type === IssueType.Error && x.AffectedEntity === entity.TableName);
      const errorfilteredIssues = this.filteredIssues && this.filteredIssues.some(x => x.Type === IssueType.Error);
      if (this.data.syncData.Reports && (errorReports || errorfilteredIssues)) {
        resultErrors = false;
        result = false;
      }
    }


    if (!resultErrors) {
      this.messageToUser = 'SYNC_DATA.VALIDATE_ERRORS';
    }

    return result;
  }

  private showSendEmails(enabledMail: boolean): void {
    this._syncDataService.isBizagiAuthenticationType().then((result: boolean) => {
      if (result === true) {
        // If there are new users and users entity selected
        if ((this._existsNewUsers === true) &&
          (this.selectedTables.findIndex((item) => item.Selected === true &&
            item.TableName.toUpperCase() === 'WFUSER') >= 0)) {
          this.showSendMailCheckbox = true;
          if (enabledMail === false) {
            this.messagebody = 'SYNC_DATA.WARNING_SMTP_CONFIGURATION';
          }
        }
        else {  // There are not new users or users entity not selected
          this.showSendMailCheckbox = false;
        }
      }
      else {    // Auhtnetication is not Bizagi
        this.data.syncData.EnabledMail = false;
        this.showSendMailCheckbox = false;
      }
    });
  }

}
